import Cookies from 'js-cookie';
import { API } from '../config/api/index';
import axios from './index';

const { get, post } = axios;

const path = API.customer.index;

const api = {};

api.login = ({ email, password, cb }) => post(path + API.customer.login, { Email:email, Password:password})
    .then(res => {
        const userId = res.data.data;
        if(res.data.data === false){
            throw new Error('อีเมล์หรือรหัสผ่านไม่ถูกต้อง');
        }else{
            Cookies.set('logedIn', true);
            Cookies.set('user', { userId} );
            console.log('login to admin id: ' + userId);
            cb(userId);
        }
    }).catch( error => { throw error; } );

api.get = ({cb}) => {
    let user = Cookies.getJSON('user');
    const { userId } = user ? user : {};
    console.log('custid=' + userId);

    get(path + API.customer.get + userId,)
    .then(res => {

        const  customer = res.data.data;

        console.log("customer: ");
        console.log(customer);

        if(res.data.data === false){
            throw new Error('ไม่พบข้อมูลผู้ใช้งาน');
        }else{

            let user = {
                name:       customer.Firstname + ' ' + customer.Lastname,
                firstname:  customer.Firstname,
                lastname:   customer.Lastname,
                email:      customer.Email,
                telephone:  customer.PhoneNumber,
                company:    customer.Company,
                address1:   customer.AddressLine1,
                address2:   customer.AddressLine2,
                city:       customer.City,
                state:      customer.State,
                postcode:   customer.Postcode,
                country:    customer.Country,
                latitude:   customer.Latitude,
                longitude:  customer.Longitude,
                franchise: customer.ReferCode,
            };

            Cookies.set('user', {
                userId: customer.ID,
                name: customer.Firstname + ' ' + customer.Lastname,
                franchise: customer.ReferCode,
                email: customer.Email,
            });
            cb(user);
        }
        
    }).catch( error => { throw error; } );
}

export default api;